import { Button, ButtonProps } from 'components/Blocks/Buttons';

import { cn } from 'styles';

type ApplyButtonProps = Pick<ButtonProps, 'onClick' | 'type' | 'className'>;

function ApplyButton({ className, onClick, ...props }: ApplyButtonProps): JSX.Element {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleApply = (e: any): void => {
    onClick?.(e);
  };

  return (
    <Button
      size="small"
      className={cn('h-auto py-1 text-xs', className)}
      color="primary"
      onClick={handleApply}
      {...props}
    >
      Apply
    </Button>
  );
}

export default ApplyButton;
